import { useState } from 'react'
import ReactGA from 'react-ga4'
import '../styles/footer.scss'

export const Footer = () => {
    const [email, setEmail] = useState('')

    return (
        <>
            <footer>
                <div className='socials-wrapper'>
                    <div className='footer-nav-social'>
                        <p>Follow Us</p>{' '}
                        <div className="socials-list">
                            <a
                                className='social-x'
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Twitter`,
                                    })
                                }}
                                aria-label='Twitter'
                                href='https://twitter.com/nisamerica'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Twitter'
                            >
                                <img
                                    alt='X logo'
                                    src={`https://nisamerica.com/public/assets/logo/twitter-x-logo-white.png`}
                                    style={{ width: '50px', height: 'auto' }}
                                />
                            </a>
                            <a
                                className='social-fb'
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Facebook`,
                                    })
                                }}
                                aria-label='Facebook'
                                href='https://www.facebook.com/NISAmericaInc/'
                                target='_blank'
                                rel='noreferrer'
                                data-label='Facebook'
                            >
                                <i className='fab fa-facebook-f fa-2x'><img style={{
                                        width: '50px',
                                        height: '50px'
                                    }}
                                    src={`${process.env.PUBLIC_URL}/img/footer/facebook.svg`} alt="" /></i>
                            </a>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS Instagram`,
                                    })
                                }}
                                aria-label='Instagram'
                                href='https://www.instagram.com/nisamerica/'
                                target='_blank'
                                rel='noreferrer'
                                className='social-ig'
                                data-label='Instagram'
                            >
                                <i className='fab fa-instagram fa-2x'><img style={{
                                        width: '50px',
                                        height: '50px',
                                        filter: 'brightness(0) invert(1)'
                                    }}
                                    src={`${process.env.PUBLIC_URL}/img/footer/instagram.svg`} alt="" /></i>
                            </a>
                            <a
                                onClick={() => {
                                    ReactGA.event({
                                        action: 'click',
                                        event: 'link',
                                        category: 'Socials',
                                        label: `NIS YouTube`,
                                    })
                                }}
                                aria-label='YouTube'
                                href='https://www.youtube.com/user/NISAmerica'
                                target='_blank'
                                rel='noreferrer'
                                className='social-yt'
                                data-label='YouTube'
                            >
                                <i className='fab fa-youtube fa-2x'>
                                    <img style={{
                                        width: '50px',
                                        height: '50px',
                                        filter: 'brightness(0) invert(1)'
                                    }}
                                    src={`${process.env.PUBLIC_URL}/img/footer/youtube.svg`} alt="" />
                                </i>
                            </a>
                        </div>
                    </div>{' '}
                </div>
                <div className='mailchimp'>
                    <form
                        action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                        method='post'
                        id='mc-embedded-subscribe-form'
                        name='mc-embedded-subscribe-form'
                        className='validate'
                        target='_blank'
                        noValidate=''
                    >
                        <div id='mc_embed_signup_scroll' className='mailchimp text-center'>
                            <div>
                                <label htmlFor='mce-EMAIL' className='subscribe text-base'>
                                    Subscribe to our mailing list to get the latest information!
                                </label>
                            </div>
                            <div className=''>
                                <div className='subscribe-wrapper'>
                                    <input
                                        className=''
                                        type='email'
                                        placeholder='Your Email'
                                        value={email}
                                        name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button
                                        onClick={() => {
                                            ReactGA.event({
                                                action: 'click',
                                                event: 'link',
                                                category: 'Socials',
                                                label: `NIS Subscribe Newsletter`,
                                            })
                                        }}
                                    >
                                        Subscribe
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className='platforms'>
                    <div className='esrb'>
                        <img src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`} alt='esrb rating' />
                    </div>
                    <img 
                        style={{
                            width: '200px',
                            height: 'auto',
                            margin: '0px 20px',
                            borderRadius: '10px'
                        }}
                        alt={'nsw logo'} 
                        src={`https://nisamerica.com/public/assets/logo/nsw2.webp`} 
                    />
                    <div className='developer pt-4'>
                        <div>
                            <img
                                style={{
                                    width: '200px',
                                    height: 'auto',
                                    filter: 'brightness(0%)'
                                }}
                                alt={'Nipponichi software'}
                                src={`https://nisamerica.com/public/assets/logo/nisj.svg`}
                            />
                        </div>
                        <div>
                            <img
                                style={{
                                    width: '280px',
                                    height: 'auto',
                                    filter: 'brightness(0%)'
                                }}
                                alt='NIS logo'
                                src={`https://nisamerica.com/public/assets/logo/nis.svg`}
                            />
                        </div>{' '}
                    </div>
                </div>
                <div className='copyrights'>
                    <div className='text-sub text-white text-center border-t-0 border-stone-300 pb-20'>
                        <p>
                            Disgaea is a trademark or registered trademark of Nippon Ichi Software, Inc.
                        </p>
                        <p className='mt-12'>
                            ©2025 Nippon Ichi Software, Inc. ©2025 NIS America, Inc. All rights reserved.
                        </p>
                        <p>Nintendo Switch is a trademark of Nintendo.</p>
                        <p>The rating icon is a trademark of the Entertainment Software Association. All other trademarks are properties of their respective owners.</p>
                        <p className='mt-4' style={{paddingTop: '25px'}}>Screenshots are taken from a development build of the game.</p>
                    </div>{' '}
                </div>
            </footer>{' '}    
        </>
    )
}